// @flow
import * as React from 'react';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import { Box } from 'gestalt';

type DownloadCrossOriginAssetProps = {|
  filename?: string,
  imgSrc: string,
  // $FlowFixMe Flow v0.104.0 upgrade supression.
  children: *,
  isUnauth?: boolean,
  category?: string,
|};

type DownloadCrossOriginAssetState = {|
  href: ?string,
|};

export const filenameFromUrl = (src: string) =>
  (
    src
      .split('\\')
      .pop()
      .split('/')
      .pop()
      // Create a capturing group for the url and ignore the query params
      // We added `?b=t` to some pin images as a remediation for IM-2971
      .match(/([^\?]+)(?:\?.*)?/) || []
  ).pop();

export default class DownloadCrossOriginAsset extends React.Component<
  DownloadCrossOriginAssetProps,
  DownloadCrossOriginAssetState,
> {
  state = { href: undefined };

  onEvent = () => {
    if (typeof window === 'undefined') {
      return;
    }

    const { imgSrc, isUnauth, category } = this.props;

    const { href } = this.state;

    if (href == null) {
      fetch(imgSrc, {
        headers: new Headers({
          Origin: location.origin,
        }),
        mode: 'cors',
      })
        .then((response) => response.blob())
        .then((blob) => {
          this.setState({ href: window.URL.createObjectURL(blob) }, () => {
            // This shouldn't be null, but just in case
            if (this.imageDownload) {
              this.imageDownload.click();
            }
          });
        })
        .catch(() => this.setState({ href: this.DOWNLOAD_ERROR }));
    }

    trackRegisterAction(
      `web.${isUnauth ? 'unauth' : 'auth'}.download.click.${category || 'no_category'}`,
    );
  };

  imageDownload: ?HTMLAnchorElement;
  imageDownloadFallback: ?HTMLAnchorElement;

  DOWNLOAD_ERROR = 'error';

  render() {
    const { children } = this.props;
    const { filename } = this.props;

    const { href } = this.state;

    const isHref = href != null && href !== this.DOWNLOAD_ERROR;

    return (
      <React.Fragment>
        {children(this.onEvent)}
        {isHref && (
          <Box display="none">
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a
              ref={(r) => (this.imageDownload = r)}
              tabIndex={-1}
              download={filename && filename.replace('.', '_')}
              href={href}
            />
          </Box>
        )}
      </React.Fragment>
    );
  }
}
